// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import Helmet from 'react-helmet';
import cx from 'classnames';
import get from 'lodash/get';
// Components
import ContactUsFormContainer from '../../containers/ContactUsForm/ContactUsFormContainer';
import OMTitle from '../../components/OMComponents/OMTitle/OMTitle';
import withPageWrapper from '../../containers/PageContainer/PageContainer';
// Helpers
import { shareUrl, ourContacts } from '../../constants';
import multiLanguageTags from '../../helpers/multiLanguageHeadTags';
import { authenticationFormatPhoneNumber } from '../../utils/formatPhoneNumber';
// Styles
import * as styles from './ContactUsPage.scss';

class ContactUsPage extends Component {
  renderContactPhone = () => (
    <a className={styles.contactItem} href={`tel:${authenticationFormatPhoneNumber(ourContacts.phone)}`} data-rel="external">
      <span className="icon icon-contacts-phone" />
      <span>{ourContacts.phone}</span>
    </a>
  );

  render() {
    const { route, location, locale, isNative } = this.props;
    const multiLanguage = multiLanguageTags(route, locale);

    return (
      <div className={cx(styles.contactPage, 'pageHeight', { [styles.native]: isNative })}>
        <Helmet
          titleTemplate={this.props.translate('title', 'titleTemplate')()}
          title={this.props.translate('title', 'contact')()}
          meta={[{
            property: 'og:title',
            content: `OnMap | ${this.props.translate('footer', 'contactUs')}`
          }]}
          link={[
            ...multiLanguage,
            { rel: 'canonical', href: `${shareUrl}${route}` }
          ]}
        />
        <div className={styles.content}>

          { !isNative && (
            (<OMTitle className="pageTitle" title={this.props.translate('contactUsPage', 'title')} />)
          ) }

          <ContactUsFormContainer isNative={isNative} />
          <div className={styles.ourContacts}>
            {this.renderContactPhone()}
            <div className={styles.contactItem}>
              <span className="icon icon-contacts-address" />
              <span>{get(ourContacts, `address[${this.props.locale}]`)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactUsPage.propTypes = {
  translate: PropTypes.func,
  isMobile: PropTypes.bool,
  route: PropTypes.string.isRequired,
  location: PropTypes.object,
  isNative: PropTypes.bool,
  locale: PropTypes.string
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'static'),
  isNative: state.native.isNative
});

export default connect(mapStateToProps)(
  withPageWrapper(ContactUsPage)
);
